import { render } from "./sabko-footer-section.vue?vue&type=template&id=ae64bb54&scoped=true"
import script from "./sabko-footer-section.vue?vue&type=script&lang=js"
export * from "./sabko-footer-section.vue?vue&type=script&lang=js"

import "./sabko-footer-section.vue?vue&type=style&index=0&id=ae64bb54&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae64bb54"]])

export default __exports__